import { Logger } from 'next-axiom';

type VerbosityLevel = 1 | 2 | 3 | 4 | 5;

interface VerbositySettings {
    level: VerbosityLevel;
    description: string;
}

const verbosityMap: Record<VerbosityLevel, VerbositySettings> = {
    1: {
        level: 1,
        description:
            'Direct and to-the-point answers, often in the form of one-liners or a single sentence.'
    },
    2: {
        level: 2,
        description:
            'Provides a little more context or explanation. Answers may consist of a couple of sentences.'
    },
    3: {
        level: 3,
        description:
            'Balanced level of verbosity. Provides a detailed explanation but without going into unnecessary depth.'
    },
    4: {
        level: 4,
        description:
            'Very detailed responses. Offers in-depth explanations and may include examples for clarification.'
    },
    5: {
        level: 5,
        description:
            'Not only provides in-depth explanations and examples, but also includes additional relevant information to enrich the understanding of the user.'
    }
};

export function getVerbositySettings(level: VerbosityLevel): VerbositySettings {
    const log = new Logger();
    log.debug('using verbosity ', { verbosity: verbosityMap[level] });
    return verbosityMap[level];
}

export function numberToVerbosityLevel(num: number): VerbosityLevel {
    if (num < 1 || num > 5) {
        throw new Error(
            'Invalid verbosity level. It should be between 1 and 5.'
        );
    }
    return num as VerbosityLevel;
}

export type { VerbosityLevel };
